<template>
  <component :is="tableType" :unit="unit"></component>
</template>
<script lang="ts">
import first from 'lodash/first';
import { TYPE } from '@/constants';

import RoundedTableMenu from './tables_rounded.vue';
import RectangularTableMenu from './tables_rectangular.vue';

export default {
  components: {
    [TYPE.TABLE_ROUNDED]: RoundedTableMenu,
    [TYPE.TABLE_RECTANGULAR]: RectangularTableMenu,
  },
  props: ['units'],
  data() {
    return {
      tableType: null,
    };
  },
  computed: {
    unit() {
      return first(this.units);
    },
  },
  created() {
    this.tableType = first(this.units).subtype;
  },
};
</script>
